import { Text, View } from '@react-pdf/renderer';
import { ReactNode } from 'react';
import styles from './styles';
import { useTranslation } from 'react-i18next';

type Props = {
  labels: string[];
  values: (string | ReactNode)[];
  maxWidthLabels?: number;
  maxWidthValues?: number;
};

function ReportForm({ labels, values, maxWidthValues }: Props) {
  const { t } = useTranslation();
  let width = 100;

  return (
    <View style={styles.table}>
      {labels.map((label, index) => (
        <View style={[styles.tableRow]} key={index}>
          <View style={[{ width: width }, styles.bold]}>
            <Text>
              {t(label)}
              {label ? ':' : ' '}
            </Text>
          </View>
          <View style={{ textAlign: 'left', maxWidth: '80%' }}>
            <Text
              style={
                maxWidthValues
                  ? {
                      width: maxWidthValues,
                    }
                  : undefined
              }
            >
              {values[index]}
            </Text>
          </View>
        </View>
      ))}
    </View>
  );
}

export default ReportForm;
